/* KINGDOM MINDED - GHOST CARD FRAME  rev 12
   Reproduces the kingdommindedlife.com card standard: visible artwork scaled to
   96% of the frame width (max 98% of frame height), optically centred, never
   cropped or altered. Model photography (under 4% transparency) and the
   approved homepage cards are never touched. */
(function () {
  'use strict';
  var SEL = '.km-card__img, .kmc-img, .km-product-row__img, .piece-media img, .nl .product-media img';
  var S = 160, FILL_W = 0.96, FILL_H = 0.98, MIN_TRANSPARENT = 0.04, cache = {};
  function isHome() { var p = location.pathname.replace(/\/+$/, ''); return p === '' || p === '/index'; }
  function bbox(img) {
    var key = img.currentSrc || img.src; if (cache[key]) return cache[key];
    var c = document.createElement('canvas'); c.width = S; c.height = S;
    var x = c.getContext('2d', { willReadFrequently: true });
    try { x.drawImage(img, 0, 0, S, S); } catch (e) { return null; }
    var d; try { d = x.getImageData(0, 0, S, S).data; } catch (e) { return null; }
    var x0 = S, y0 = S, x1 = -1, y1 = -1, opaque = 0, i, px, py;
    for (py = 0; py < S; py++) for (px = 0; px < S; px++) { i = (py * S + px) * 4 + 3; if (d[i] > 8) { opaque++; if (px < x0) x0 = px; if (px > x1) x1 = px; if (py < y0) y0 = py; if (py > y1) y1 = py; } }
    if (x1 < 0) return null;
    if (1 - opaque / (S * S) < MIN_TRANSPARENT) return null;
    var r = { w: (x1 - x0 + 1) / S, h: (y1 - y0 + 1) / S, cx: ((x0 + x1 + 1) / 2) / S, cy: ((y0 + y1 + 1) / 2) / S };
    cache[key] = r; return r;
  }
  function fit(img) {
    if (!img.complete || !img.naturalWidth) return false;
    if (getComputedStyle(img).objectFit !== 'contain') return false;
    var b = bbox(img); if (!b) return false;
    var lw = img.offsetWidth, lh = img.offsetHeight; if (!lw || !lh) return false;
    var k = Math.min(lw / img.naturalWidth, lh / img.naturalHeight);
    var dw = img.naturalWidth * k, dh = img.naturalHeight * k, gw = dw * b.w, gh = dh * b.h;
    if (!gw || !gh) return false;
    var s = Math.min(FILL_W * lw / gw, FILL_H * lh / gh), st = img.style;
    st.setProperty('--km-gs', s.toFixed(4));
    st.setProperty('--km-gx', (-dw * (b.cx - 0.5) * s).toFixed(2) + 'px');
    st.setProperty('--km-gy', (-dh * (b.cy - 0.5) * s).toFixed(2) + 'px');
    return true;
  }
  function pass() { if (isHome()) return; [].slice.call(document.querySelectorAll(SEL)).forEach(fit); }
  function boot() {
    if (isHome()) return;
    [].slice.call(document.querySelectorAll(SEL)).forEach(function (i) {
      i.decoding = 'sync';
      if (i.complete && i.naturalWidth) { if (i.decode) { i.decode().then(function () { fit(i); }, function () { fit(i); }); } else { fit(i); } }
      else { i.addEventListener('load', function () { fit(i); }, { once: true }); }
    });
    requestAnimationFrame(pass);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(pass, 180); });
  window.KMGhostFrame = { run: pass, size: pass };
})();
